const searchPlaceHolderConstantsAr = {
  searchPlaceHolder: 'بحث',
};
export default searchPlaceHolderConstantsAr;
